import React from 'react'
import List from './List'
import { usePositionJobDescById } from 'src/queries'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const position = usePositionJobDescById(id)
  return (
    <List position={position} />
  )
}

export default Body
